import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  listaCabecalho: {
    display: "flex",
    justifyContent: "space-around",
    width: "100%",
    padding: "0",
    [theme.breakpoints.up("sm")]: {
      display: "flex",
      justifyContent: "space-around",
      width: "100%",
      padding: "0",
    },
  },

  containerButtons: {
    display: "flex",
    justifyContent: "flex-end",
    "& button:first-child": {
      marginTop: "2rem",
    },
  },

  Bandeira: {
    width: 40,
    height: 40,
    marginRight: theme.spacing(2),
    borderRadius: theme.spacing(0.5),
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  },

  IconButton: {
    color: `${theme.palette.error.main} !important`,
    '&:hover': {
      backgroundColor: `${theme.palette.error.main}10 !important`,
    },
  },
  
  Titulo: {
    paddingBottom: 0,
    [theme.breakpoints.up("sm")]: {
      paddingBottom: theme.spacing(1.5),
      fontSize: "16px",
    },
  },
  
  Grid: {
    display: "block",
    padding: 0,
    [theme.breakpoints.up("sm")]: {
      padding: 0,
      margin: "auto",
    },
  },
  
  descricao: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      marginTop: 0,
    },
  },
  
  IconeOuro: {
    width: 40,
    height: 40,
    marginRight: theme.spacing(2),
    borderRadius: theme.spacing(0.5),
  },

  Step: {
    background: theme.palette.grey[100],
    padding: theme.spacing(1.5),
    alignItems: "center",
    marginBottom: theme.spacing(1),
    display: "flex",
    justifyContent: "space-between",
    borderRadius: theme.spacing(1),
    [theme.breakpoints.up("sm")]: {
      marginTop: 0,
    },
  },
  
  Botao: {
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "auto",
    },
  },

  Number: {
    textAlign: "center",
    background: theme.palette.primary.main,
    padding: theme.spacing(0.5),
    borderRadius: "50%",
    width: 24,
    height: 24,
    fontSize: "12px",
    color: "white",
    fontWeight: 600,
  },

  TextStep: {
    fontSize: "14px",
    fontWeight: 600,
  },

  Step2: {
    background: theme.palette.grey[300],
    padding: theme.spacing(1.5),
    alignItems: "center",
    marginBottom: theme.spacing(1),
    display: "flex",
    justifyContent: "space-between",
    borderRadius: theme.spacing(1),
    opacity: 0.7,
    [theme.breakpoints.up("sm")]: {
      marginTop: 0,
    },
  },
}));

export default useStyles;